// extracted by mini-css-extract-plugin
export var header = "_ux-1";
export var maskBottom = "_ux-6";
export var maskMiddle = "_ux-7";
export var maskTop = "_ux-5";
export var root = "_ux-0";
export var scrollDownButton = "_ux-3";
export var scrollDownButtonHidden = "_ux-4";
export var viewport = "_ux-2";